var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.show}},[_c('div',{staticClass:"imgLoading"},[_c('van-loading',{attrs:{"type":"spinner","color":"#ffffff"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }